import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import axios from "axios";
import api from "./api";

Vue.config.productionTip = false;

// форматирование дат
Vue.filter('toDate', function (value) {
  return new Date(value).toLocaleDateString()
})
// забираем токен из хранилища
const token = localStorage.getItem("token");
if (token) axios.defaults.headers.common["X-Api-Key"] = token;

/* если пользователь не авторизирован, то отправляем на страницу логина*/
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.name !== "login" && !token) {
    next({ name: "login" });
  }
  next();
});

/* глобавльная првоерка ответа и переадресация на логин */
axios.interceptors.response.use(
  resp => resp,
  err => {
    if (err.response.status === 401 || err.response.status === 403) {
      // удаляем всю инфу о юзере
      store.currentUser = {};
      axios.defaults.headers.common["X-Api-Key"] = "";
      localStorage.removeItem("token");
      // переадресовываем на страницу авторизации
      router.push({ name: "login" });
      return Promise.reject(err);
    } else {
      return Promise.reject(err);
    }
  }
);

new Vue({
  router,
  vuetify,
  render: h => h(App),
  data: {
    store: store
  }
}).$mount("#app");
